import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import Register from './pages/Register'
import ProdutorDashboard from './pages/produtor/Dashboard'
import ProdutorEditais from './pages/produtor/Editais'
import ProdutorPerfil from './pages/produtor/Perfil'
import AgroeconomiaDashboard from './pages/agroeconomia/Dashboard'
import EducacaoDashboard from './pages/educacao/Dashboard'

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, user, loading } = useAuth()

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Carregando...</div>
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.tipo)) {
    return <Navigate to="/" replace />
  }

  return children
}

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        <Route
          path="/produtor"
          element={
            <PrivateRoute allowedRoles={['produtor']}>
              <ProdutorDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/produtor/editais"
          element={
            <PrivateRoute allowedRoles={['produtor']}>
              <ProdutorEditais />
            </PrivateRoute>
          }
        />
        <Route
          path="/produtor/perfil"
          element={
            <PrivateRoute allowedRoles={['produtor']}>
              <ProdutorPerfil />
            </PrivateRoute>
          }
        />
        
        <Route
          path="/agroeconomia"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']}>
              <AgroeconomiaDashboard />
            </PrivateRoute>
          }
        />
        
        <Route
          path="/educacao"
          element={
            <PrivateRoute allowedRoles={['educacao']}>
              <EducacaoDashboard />
            </PrivateRoute>
          }
        />
        
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  )
}

export default App

